import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererbatchPreparationMain',
  template: `
    <button
      mat-mini-fab
      color="accent"
      (click)="onClick($event)"
      pTooltip="Operation History"
      tooltipPosition="top"
    >
      <mat-icon>history</mat-icon>
    </button>

    <button
    [disabled]="this.params.data.BatchNo"
      mat-mini-fab
      color="primary"
      (click)="onClick($event)"
      pTooltip="Map Machine"
      tooltipPosition="top"
    >
      <mat-icon>add</mat-icon>
    </button>
    <button
  *ngIf="this.params.data?.TheoraticalHMFValue"
  [disabled]="!this.params?.data.isSendEmail"
  mat-mini-fab
  color="warn"
  (click)="onClick($event)"
  pTooltip="Print QR code"
  tooltipPosition="top"
>
  <mat-icon>qr_code</mat-icon>
</button>
  <button *ngIf="!this.params.data.isSendEmail && this.params.data?.TheoraticalHMFValue"
  mat-raised-button="" color="primary" ptooltip="Send Mail" tooltipposition="top"
  class="mat-focus-indicator mat-raised-button mat-button-base mat-primary ng-star-inserted" style="background-color: #1cd154;"><span class="mat-button-wrapper" style="
    color: white;font-weight: bold;">{{this.params.data.loadingStatus=='Pending' || this.params.data.loadingStatus=='Fail' ? 'Send Email Pre-Loading':
    this.params.data.MixingStatus=='Pending' || this.params.data.MixingStatus=='Fail' ? 'Send Email Post-Mixing':'Send Email Pre-Pumping'}}</span>
    <span matripple="" class="mat-ripple mat-button-ripple"></span>
    <span class="mat-button-focus-overlay"></span>
  </button>
  `
})
// tslint:disable-next-line:component-class-suffix
export class BtnRendererbatchPreparationMain
  implements ICellRendererAngularComp, OnDestroy {
  public params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(params);
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
